module.exports = __webpack_public_path__ + "img/cx_icon_05.png";